const findScrollableParent = (element) => {
  // document.body does not have scrollHeight, but documentElement does
  if (element.style.position === 'fixed')
    return window.document.documentElement;
  const excludeStaticParent = element.style.position === "absolute";
  let currentElement = element;
  do {
    if (excludeStaticParent && currentElement.style.position === 'static')
      continue;
    const elStyle = getComputedStyle(currentElement);
    if (/(auto|scroll)/.test(elStyle.overflow + elStyle.overflowX + elStyle.overflowY))
      break;
  } while (currentElement = currentElement.parentElement);
  return currentElement || window.document.documentElement;
};

export { findScrollableParent as f };
